// extracted by mini-css-extract-plugin
module.exports = {"dpu-calculator-header":"Header_dpu-calculator-header__OGFZg"};